import React, { Suspense, lazy, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Routes } from 'react-router-dom'

import LoadingComponent from 'components/LoadingComponent'
import Layout from 'components/layouts/main-layout'
import IdleLogout from 'components/timers/impersonate-timer'

import { logout, stopUserImpersonate } from 'services/api'

import ImpersonateLoginPage from 'pages/impersonate-login'
import NotFoundPage from 'pages/not-found'

import { useUser } from 'UserContext'
import { privateRoutes } from 'routes/config'
import PrivateRoute from 'routes/private-route'
import PublicRoute from 'routes/public-route'

const Login = lazy(() => import('./pages/Login'))

function App() {
  const { i18n } = useTranslation()
  const Guarded = ({ Component, required = [] }) => (
    <PrivateRoute required={required}>
      <Component />
    </PrivateRoute>
  )
  const { user } = useUser()
  const isImpersonating = !!user?.impersonated

  const lang = i18n.language

  useEffect(() => {
    i18n.changeLanguage(user?.lang_preferred || lang)
  }, [user?.lang_preferred])

  return (
    <div className="App">
      <IdleLogout
        isImpersonating={isImpersonating}
        onLogoutImpersonate={stopUserImpersonate}
        onLogout={logout}
      />
      <Suspense fallback={<LoadingComponent />}>
        <Routes>
          {/* Pública */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/impersonate"
            element={
              <PublicRoute>
                <ImpersonateLoginPage />
              </PublicRoute>
            }
          />

          {/* Bloque privado: layout + children */}
          <Route
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            {privateRoutes.map(({ path, component: Component, required }, i) => (
              <Route
                key={path || i}
                path={path}
                element={<Guarded Component={Component} required={required} />}
              />
            ))}

            {/* <Route path="*" element={<NotFoundPage />} /> */}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  )
}

export default App
